{
  "short": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  "to": "to"
}
